import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const filters = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: 'api.filters',
    tagTypes: ['filters'],
    endpoints: (builder) => ({
        platforms: builder.query<any, {
            workspace: any
        }>({
            query: ({ workspace }) => {
                const url = `/filters/platforms`;
                const body = {
                    workspace
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        countries: builder.query<any, {
            workspace: any,
            platforms: any,
            startDate: any,
            endDate: any
        }>({
            query: ({ workspace, platforms, startDate, endDate }) => {
                const url = `/filters/countries`;
                const body = {
                    workspace,
                    platforms,
                    startDate,
                    endDate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        searchTerms: builder.query<any, {
            workspace: any,
            platforms: any,
            devices: any,
            clusters: any,
            startDate: any,
            countries: any
            endDate: any
        }>({
            query: ({ workspace, platforms, startDate, endDate, devices, countries , clusters}) => {
                const url = `/filters/search-terms`;
                const body = {
                    workspace,
                    platforms,
                    devices,
                    startDate,
                    endDate,
                    countries,
                    clusters
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        clusters: builder.query<any, {
            workspace: any,
            platforms: any,
            devices: any,
            countries: any,
            startDate: any,
            endDate: any
        }>({
            query: ({ workspace, platforms, devices, countries, startDate, endDate }) => {
                const url = `/filters/clusters`;
                const body = {
                    workspace,
                    platforms,
                    devices,
                    countries,
                    startDate,
                    endDate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        })

    }),
});

export const {
    usePlatformsQuery,
    useCountriesQuery,
    useSearchTermsQuery,
    useClustersQuery
} = filters;

export default filters;
